import GuiContext from "config/context/guiContext";
import { useContext, useEffect, useRef, useState } from "react";

// Blok traje pola sekunde, pa češće pitanje ne donosi ništa. Na mreži sa jednim
// proizvođačem odgovor stiže iz prvog pokušaja; na pravoj se čeka minutima i
// tada je ovaj razmak ionako zanemarljiv.
const INTERVAL_MS = 2000;

// Posle ovoga se prestaje pitati, ali se NE tvrdi da je propalo. Predugo
// čekanje znači da nešto nije u redu sa mrežom ili čvorom — a to je drugo od
// „transakcija je odbačena", i korisniku se ne sme reći kao da je isto.
const GIVE_UP_MS = 5 * 60 * 1000;

/**
 * Da li je blok postao nepovratan.
 *
 * Prati se samo ono što je nepovratno PO NAMERI — predaja i brisanje baze. Za
 * ostale upise ovo bi bio ukras: značka koja ne pokreće nijednu odluku.
 *
 * ZAMKA PRI PROVERI, i uhvatiće svakoga ko gleda lokalno: na razvojnom čvoru sa
 * jednim proizvođačem LIB kasni jedan blok, dakle oko pola sekunde (izmereno
 * 01.09.2026). Stanje `waiting` bljesne i nestane, pa deluje kao da ne radi. Na
 * mreži sa 21 proizvođačem to su minuti i tek se tamo vidi čemu služi.
 *
 * @param {number|null|undefined} blockNum blok koji treba da postane nepovratan
 * @returns {{state: "idle"|"waiting"|"final"|"unknown", head: number, irreversible: number}}
 */
export const useIrreversible = (blockNum) => {
    const [state, setState] = useState("idle");
    const [chain, setChain] = useState({ head: 0, irreversible: 0 });
    const { selected: { selectedServer }, URL } = useContext(GuiContext);
    const startedRef = useRef(0);

    useEffect(() => {
        if (!blockNum || !selectedServer) {
            setState("idle");
            return undefined;
        }

        let otkazan = false;
        startedRef.current = Date.now();
        setState("waiting");

        const pitaj = async () => {
            try {
                const res = await fetch(`${URL}/api/database/finality`, {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ server_url: selectedServer }),
                });
                const body = await res.json();
                if (otkazan) return;
                if (body?.status !== true) return;

                setChain({ head: body.head, irreversible: body.irreversible });
                if (body.irreversible >= blockNum) {
                    setState("final");
                    clearInterval(timer);
                } else if (Date.now() - startedRef.current > GIVE_UP_MS) {
                    // Prestajemo da pitamo, ali ne presuđujemo. Vidi `GIVE_UP_MS`.
                    setState("unknown");
                    clearInterval(timer);
                }
            } catch (error) {
                // Promašen poziv nije odgovor. Sledeći otkucaj pokušava ponovo;
                // tek istek vremena menja stanje.
            }
        };

        const timer = setInterval(pitaj, INTERVAL_MS);
        pitaj();

        return () => {
            otkazan = true;
            clearInterval(timer);
        };
    }, [blockNum, selectedServer, URL]);

    return { state, ...chain };
};
